import * as types from './mutation-types'
import { services } from './api'
import Cookies from 'js-cookie'

export const fetchProduct = ({ commit }) => {
  // API request
  return services.products.getAll()
  .then((response) => {
    console.log(response)
    commit(types.FETCH_PRODUCT, response.data)
  })
  .catch((error) => {
    console.error(error)
  })
}

export const fetchProfile = ({ commit }) => {
  // API request
  return services.profile.getProfile()
  .then((response) => {
    console.log(response)
    commit(types.FETCH_PROFILE, response.data)
  })
  .catch((error) => {
    console.error(error)
  })
}

export const fetchPerfil = ({ commit }) => {
  // API request
  return services.perfil.getPerfil()
  .then((response) => {
    console.log(response)
    commit(types.FETCH_PERFIL, response.data)
  })
  .catch((error) => {
    console.error(error)
  })
}

export const logoutPerfil = ({ commit }) => {
  // API request
  return services.perfil.logoutPerfil()
  .then((response) => {
    console.log(response)
    commit(types.LOGOUT_PERFIL)
  })
  .catch((error) => {
    console.error(error)
  })
}


export const fetchCurrentUser = ({ commit }) => {
  // API request
  return commit(types.FETCH_CURRENT_USER, "tESTE")
}

export const setCarrinho = ({ commit },itensCarrinho) => {
  commit(types.SET_CARRINHO, { itensCarrinho })

  Cookies.set('itensCarrinho', itensCarrinho)
}


export const adicionarProduto = ({ commit }, produto) => {
  commit(types.ADICIONAR_PRODUTO, produto)
}

export const atualizarProdutos = ({ commit }, produtos) => {
  commit(types.ATUALIZAR_PRODUTOS, produtos)
}
export const limparProdutos = ({ commit }) => {
  commit(types.LIMPAR_PRODUTOS)
}
export const removerProduto = ({ commit }, index) => {
  commit(types.REMOVER_PRODUTO, index)
}

export const editarProduto = ({ commit }, item) => {
  commit(types.EDITAR_PRODUTO, item)
}
export const valorAleatorio = ({ commit }) => {
  commit(types.VALOR_ALEATORIO)
}



//PRODUTO ATIVO
export const atualizarProdutoAtivo = ({ commit }, produto) => {
  commit(types.ATUALIZAR_PRODUTO_ATIVO, produto)
}
export const removerProdutoAtivo = ({ commit }) => {
  commit(types.REMOVER_PRODUTO_ATIVO)
}
export const editarProdutoCarrinho = ({ commit }, item) => {
  commit(types.EDITAR_PRODUTO_CARRINHO, item)
}

//PIZZA ATIVA
export const atualizarPizzaAtiva = ({ commit }, pizza) => {
  commit(types.ATUALIZAR_PIZZA_ATIVA, pizza)
}
export const removerPizzaAtiva = ({ commit }) => {
  commit(types.REMOVER_PIZZA_ATIVA)
}

//CLONE ATIVO
export const atualizarCloneAtivo = ({ commit }, clone) => {
  commit(types.ATUALIZAR_CLONE_ATIVO, clone)
}
export const removerCloneAtivo = ({ commit }) => {
  commit(types.REMOVER_CLONE_ATIVO)
}

//ENDEREÇO ATIVO
export const atualizarEnderecoAtivo = ({ commit }, endereco) => {
  commit(types.ATUALIZAR_ENDERECO_ATIVO, endereco)
}
export const removerEnderecoAtivo = ({ commit }) => {
  commit(types.REMOVER_ENDERECO_ATIVO)
}

export const showModalAddCarrinho = ({ commit }) => {
  commit(types.SHOW_MODAL_ADDCARRINHO)
}
export const showModalLogin = ({ commit }) => {
  commit(types.SHOW_MODAL_LOGIN)
}
export const showModalEndereco = ({ commit }) => {
  commit(types.SHOW_MODAL_ENDERECO)
}
export const hideModalEndereco = ({ commit }) => {
    commit(types.HIDE_MODAL_ENDERECO)
  }
export const showModalFinalizarCompra = ({ commit }) => {
  commit(types.SHOW_MODAL_FINALIZAR_COMPRA)
}
export const hideModalFinalizarCompra = ({ commit }) => {
  commit(types.HIDE_MODAL_FINALIZAR_COMPRA)
}
export const hideAllModals = ({ commit }) => {
    commit(types.HIDE_ALL_MODALS)
  }


